// @ts-nocheck

import React, { useContext, useMemo } from 'react';
import { Group, Image, Line } from 'react-konva';

import BetshareContext from '../contexts/BetshareContext';
import { getRelativeValue } from '../utils';

import ScalableText from './ScalableText';

const LabelledBloc = (props) => {
  const { x, y, amount, picto, caption } = props;
  const { stageWidth } = useContext(BetshareContext);

  const shapePoints = useMemo(
    () => [
      0,
      0,
      getRelativeValue(90, stageWidth),
      0,
      getRelativeValue(88, stageWidth),
      getRelativeValue(10, stageWidth),
      getRelativeValue(117, stageWidth),
      getRelativeValue(10, stageWidth),
      getRelativeValue(110, stageWidth),
      getRelativeValue(42, stageWidth),
      0,
      getRelativeValue(42, stageWidth),
    ],
    [stageWidth],
  );

  return (
    <Group x={x} y={y}>
      <Group x={getRelativeValue(2, stageWidth)} y={getRelativeValue(2, stageWidth)}>
        <Line points={shapePoints} fill="#666" closed />
      </Group>
      <Line points={shapePoints} fill="#000" closed />
      <ScalableText
        text={caption.toUpperCase()}
        fontSize={getRelativeValue(10, stageWidth)}
        fontFamily="BettingPoliticaItalic, sans-serif"
        x={getRelativeValue(50, stageWidth)}
        y={getRelativeValue(3, stageWidth)}
        width={getRelativeValue(35, stageWidth)}
        height={getRelativeValue(10, stageWidth)}
        fill="#ffc514"
        verticalAlign="middle"
        align="left"
      />
      <Image
        image={picto}
        x={getRelativeValue(-5, stageWidth)}
        y={getRelativeValue(-10, stageWidth)}
        width={getRelativeValue(44, stageWidth)}
        height={getRelativeValue(60, stageWidth)}
      />
      <ScalableText
        text={amount}
        fontSize={getRelativeValue(20, stageWidth)}
        lineHeight={1.2}
        fontFamily="BettingPoliticaExtraBold, sans-serif"
        x={getRelativeValue(42, stageWidth)}
        y={getRelativeValue(14, stageWidth)}
        width={getRelativeValue(67, stageWidth)}
        height={getRelativeValue(28, stageWidth)}
        align="center"
        fill="#fff"
        verticalAlign="middle"
      />
    </Group>
  );
};

export default LabelledBloc;
